import { ref } from 'vue'

const DEFAULT_SOURCE = 'customer-web'
const DEFAULT_TYPE = 'original'

const VALID_TYPES = ['original', 'ai-upscaled', 'ai-generated']

const VALID_SOURCES = [
  'customer-web',
  'freepik',
  'snappr',
  'slice',
  'third-party-dd',
  'third-party-ue',
  'third-party-gh',
  'third-party-other',
  'unknown',
]

export const useImageSourceDialog = () => {
  const selectedSource = ref(DEFAULT_SOURCE)
  const selectedType = ref(DEFAULT_TYPE)
  const showSourceDialog = ref(false)

  const openSourceDialog = (
    currentSource?: string | null,
    currentType?: string | null
  ) => {
    selectedSource.value =
      currentSource && VALID_SOURCES.includes(currentSource)
        ? currentSource
        : DEFAULT_SOURCE
    selectedType.value =
      currentType && VALID_TYPES.includes(currentType)
        ? currentType
        : DEFAULT_TYPE
    showSourceDialog.value = true
  }

  const closeSourceDialog = () => {
    showSourceDialog.value = false
  }

  const resetSource = () => {
    selectedSource.value = DEFAULT_SOURCE
    selectedType.value = DEFAULT_TYPE
  }

  return {
    closeSourceDialog,
    openSourceDialog,
    resetSource,
    selectedSource,
    selectedType,
    showSourceDialog,
  }
}
